
import React from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { IconButton } from "components"
import classes from "./OrderDetailCancelButton.module.scss"

const OrderDetailCancelButton = props => {
  const { setShowConfirmationModal } = props

  const [t, i18n] = useTranslation()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={classes["container"]}
      onClick={() => setShowConfirmationModal(true)}
    >
      <IconButton
        icon={MdClose}
        size={18}
        color="var(--color-danger)"
      />
      <span
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        {t("لغو_سفارش")}
      </span>
    </div>

  )
}

export default OrderDetailCancelButton